exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-heading[data-v-471fa6c4]{color:#006b8d;border-bottom:2px solid #006b8d!important}.panel-heading h4[data-v-471fa6c4]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.panel-flat[data-v-471fa6c4]{overflow-x:hidden!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-471fa6c4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/customer/exportOrder/addExportOrder.vue
// module id = 738
// module chunks = 0